import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SettingsService } from 'src/app/services/account/settings.service';
import { StackedModalsService } from 'src/app/services/modal/stacked-modals.service';
import { SettingsDialogComponent } from '../../modals/settings-dialog/settings-dialog.component';

/**
 * Widget mode replacement for the profile menu: a single icon that opens the
 * settings dialog. Positioned by the parent (fixed card on desktop, inline in
 * the mobile header).
 */
@Component({
  standalone: true,
  selector: 'app-widget-settings-button',
  templateUrl: './widget-settings-button.component.html',
  styleUrls: ['./widget-settings-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WidgetSettingsButtonComponent {
  public readonly settingsService = inject(SettingsService);
  private readonly stackedModalsService = inject(StackedModalsService);

  public openSettings(): void {
    this.stackedModalsService.openModal(SettingsDialogComponent, {
      autoFocus: false,
      panelClass: 'dialog-snap-to-fullscreen'
    });
  }
}
